import React from 'react';

import { Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

export const columns = [
  {
    title: 'International Supply Chain Identification',
    dataIndex: 'supplyChainIdentification',
    key: 'supplyChainIdentification',
    colSpan: 1,
  },
  {
    title: "KYC",
    dataIndex: 'kyc',
    className: 'text-center',
    key: 'kyc',
    colSpan: 1,
    render: value => value ? <CheckOutlined style={{ color: "#23af52" }} /> : null,
  },
  {
    title: 'Red-Flag Assessment',
    dataIndex: 'redFlagAssessment',
    className: 'text-center',
    key: 'redFlagAssessment',
    colSpan: 1,
    render: value => value ? <CheckOutlined style={{ color: "#23af52" }} /> : null,
  },
  {
    title: 'Onboarding Documentation',
    dataIndex: 'documentation',
    className: 'text-center',
    key: 'documentation',
    colSpan: 1,
    render: value => <span style={{ color: "#23af52" }}>{value}%</span>,
  },
  {
    title: 'Actions',
    key: 'actions',
    colSpan: 1,
    render: () => <Button size="small" type="primary">Details</Button>
  }
];

export const data = [
  {
    key: '1',
    supplyChainIdentification: (<span>Exporter <span className="color-red">(*)</span></span>),
    kyc: true,
    redFlagAssessment: true,
    documentation: 90,
  },
  {
    key: '2',
    supplyChainIdentification: (<span>Intermediary <span className="color-red">(*)</span></span>),
    kyc: true,
    redFlagAssessment: true,
    documentation: 100,
  },
  {
    key: '3',
    supplyChainIdentification: 'International Trading SA',
    kyc: true,
    redFlagAssessment: true,
    documentation: 100,
  }
];

const all = {
  columns,
  data,
};

export default all;
